import type { JSX } from "preact";
import { Auth } from "@gss/common/Auth";
import { Button } from "./Button";
import { Login, Logout } from "./icons";
import { useMessages } from "./Messages";

interface Props {
    translation: {
        menu: {
            login: string;
            logout: string;
        };
        error: {
            login: string;
            logout: string;
        };
    };
}

export function MenuLoginButton({ translation }: Props): JSX.Element {
    const { addError } = useMessages();

    const onLoginClick = () => {
        if (Auth.isAuthenticated()) {
            Auth.logout().catch((error: unknown) => {
                addError({
                    message: translation.error.logout,
                    cause: error,
                });
            });
        } else {
            Auth.login().catch((error: unknown) => {
                addError({
                    message: translation.error.login,
                    cause: error,
                });
            });
        }
    };

    return (
        <Button
            variant="light"
            className="menu-login-button"
            onClick={onLoginClick}
        >
            {Auth.isAuthenticated() ? (
                <>
                    {translation.menu.logout} <Logout aria-hidden />
                </>
            ) : (
                <>
                    {translation.menu.login} <Login aria-hidden />
                </>
            )}
        </Button>
    );
}
